import "../../../styles/stores/messages/message.css";
import EachMessage from "./EachMessage";
import Chats from "./Chats";
import { useNavigate } from "react-router-dom";
import { getMessageUrl } from "../../../api/endpoints";
import { useEffect, useState, useLayoutEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import MessageDetail from "./MessageDetail";
import { updateSelectedMessage, setSelectedMessage, dropSelectedMessage } from "../../../slice/MessageSlice";
import Spinner from "../../../components/uxCollections/Loaders";
import { refreshUserToken } from "../../../tools/refreshToken";
import chatBubble from "../../../assetsStatic/chatBubble.png";
import { uiAlert } from "../../../components/alerts/customAlert/uiAlert";

const MessagesPage = ({ socket }) => {
  const [conversationList, setConversationList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { store } = useSelector((state) => state.store);
  const { selectedConversation } = useSelector((state) => state.selectedConversation);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useLayoutEffect(() => {
    console.log("selected", selectedConversation);
    fetchMessages();
    socket.on("newMessage", (data) => {
      /* console.log("new message", data); allConversation */
      let { allConversation, currentConversation } = data;

      setConversationList(allConversation.conversation);
    });

    socket.on("refresh", (data) => {
      console.log("refreshing", data);
      setConversationList(data.allConversation.conversation);
    });

    return () => {
      console.log("unmounting");
      socket.off("newMessage");
      socket.off("refresh");
      socket.off("userConnected");
      socket.off("userDisconnected");
      dispatch(dropSelectedMessage());
    };
  }, []);

  useEffect(() => {
    socket.on("userDisconnected", (data) => {
      console.log("user disconnected", data);
      let newChatList = conversationList.map((conversation) => {
        let newConversation = JSON.parse(JSON.stringify(conversation));
        if (newConversation.customer.id === data.userID) {
          newConversation.customer.isOnline = false;
        }
        return newConversation;
      });
      setConversationList(newChatList);
    });
    /* user coneected */
    socket.on("userConnected", (data) => {
      console.log("user connected", data);
      let newChatList = conversationList.map((conversation) => {
        let newConversation = JSON.parse(JSON.stringify(conversation));
        if (newConversation.customer.id === data.userID) {
          newConversation.customer.isOnline = true;
        }
        return newConversation;
      });
      setConversationList(newChatList);
    });

    return () => {};
  }, [conversationList]);

  useEffect(() => {
    socket.on("newMessage", (data) => {
      /* console.log("new message", data); allConversation */
      let { _, currentConversation } = data;
      fetchMessages();
      if (selectedConversation) {
        console.log("checking", selectedConversation.conversationID, currentConversation.conversationID);
        selectedConversation.conversationID === currentConversation.conversationID && dispatch(setSelectedMessage(currentConversation));
      } else {
        console.log(selectedConversation);
        console.log("no selecetedConversation");
      }
    });

    return () => {
      socket.off("newMessage");
    };
  }, [selectedConversation]);

  const fetchMessages = async () => {
    let accessToken = localStorage.getItem("accessToken");
    try {
      const response = await fetch(getMessageUrl + store._id, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });
      if (response.ok) {
        const messages = await response.json();
        console.log(messages);
        messages.length > 0 &&
          messages.conversation.forEach((message) => {
            message.customer = { ...message.customer, isOnline: false };

            /* Object.defineProperties(message.customer, { isOnline: { configurable: true, writable: true } }); */
          });

        setConversationList(messages.conversation);
        setIsLoading(false);
      } else if (response.status === 400) {
        refreshUserToken(getMessageUrl + store._id, fetchMessages, navigate);
      } else {
        uiAlert("something went wrong", "error");
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div className='messageWrapperDiv'>
        {isLoading ? (
          <Spinner />
        ) : conversationList?.length > 0 ? (
          <div className='messageComWrapper'>
            <div className=''>
              {/* each message */}

              {conversationList?.map((conversation) => (
                <EachMessage key={conversation.conversationID} conversation={conversation} selectedConversation={selectedConversation} />
              ))}
            </div>
            {selectedConversation ? (
              <MessageDetail socket={socket} selecetedMessage={selectedConversation} updateSeletedMessage={updateSelectedMessage} store={store} />
            ) : (
              <div className='noSelectedMesage221'>
                {/* <img src={require("../../../assetsStatic/chatBubble.png")} /> */}
                <img src={"https://res.cloudinary.com/ebuka1122/image/upload/v1710424038/static%20images%20storelens/chatBubble_katxeu.png"} />
                <h3>Storelense Chat</h3>
                <p>
                  Receive and reply messages <br /> from your online customer here. Messages are monitored <br /> for compliance sake.{" "}
                  <a href='#'>Learn more</a>
                </p>
              </div>
            )}
          </div>
        ) : (
          <div className='noMessageDiv'>
            <img src={"https://res.cloudinary.com/ebuka1122/image/upload/v1710425092/static%20images%20storelens/emptyMessage_s6v6zj.png"} />
          </div>
        )}
      </div>
    </>
  );
};

export default MessagesPage;
